// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar } from '@mui/material';
//
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';
import { useSelector, RootState } from '../../redux/store';

// ----------------------------------------------------------------------

// const DRAWER_WIDTH = 280;
// const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72)
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

// ----------------------------------------------------------------------

const HeaderBreadcrumb = styled('span')(({ theme }) => ({
  lineHeight: '70px',
  marginLeft: 15,
  color: 'gray',
  display: 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'inline-block'
  }
}));

export default function DashboardNavbar() {
  const { workspace } = useSelector((state: RootState) => state.workspace);

  return (
    <RootStyle>
      <ToolbarStyle>
        <div
          style={{
            display: 'inline-flex',
            color: 'black',
            alignItems: 'center'
          }}
        >
          {workspace ? (
            <img
              src={workspace.wsLogo}
              alt={workspace.wsName}
              style={{
                maxWidth: '160px',
                maxHeight: '70px',
                padding: 0,
                width: '100%',
                height: 'fit-content'
              }}
            />
          ) : null}
          <HeaderBreadcrumb>| Área de Cliente</HeaderBreadcrumb>
        </div>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          <NotificationsPopover />
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
